const pagesAppOrgSettingsEn = {
  integrationFeatures: {
    title: "Integration Features",
    description:
      "Configure the overall integration preferences here. Keep in mind that individual apps may have their own integration settings that can override these general preferences. To fully leverage the advantages of Dress Code, it's recommended to activate all available integration features.",
    enabled: "Enabled",
    disabled: "Disabled",
    features: {
      USER_LIST: "User List",
      USER_PROVISIONING: "User Provisioning",
    },
    editDialog: {
      trigger: "Edit",
      title: "Edit integration features",
      description:
        "Enabling a integration feature may require re-authentication.",
      cancel: "Cancel",
      save: "Save",
      enable: "Enable",
      disable: "Disable",
      confirmTitle: "Are you sure you want to proceed with this action?",
      confirmDescription: "These settings will apply to all the integrations.",
      saved: "Saved successfully",
    },
    resultDialog: {
      title: "Please reauthenticate the following apps",
      description:
        "The integration features may not work if you did not reauthenticate.",
      close: "Close",
    },
  },
};

export default pagesAppOrgSettingsEn;
